import { Icons } from '@lacedltd/laced-components'
import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const ToggleDotContainer = styled.div({
  position: 'relative'
})

export const StyledDot = styled(Icons.Dot)({
  position: 'absolute',
  top: tokens.spacing[2],
  right: tokens.spacing[2],
  color: tokens.color.airJordan.p
})
